module.exports = __webpack_public_path__ + "img/stamp card 32 Icon - white.5944d383.svg";